import React, { Component } from "react";
import axios from "axios";
import { Link } from "react-router-dom";

import { Globals } from "../constants";
import {
  loginUser,
  tempUser,
  handleGoogleEvents,
  getSubscriptionAPIURL,
  validatePhone,
  getTelcoName,
} from "../HelperFunctions";

import Timer from "react-compound-timer/build";

class LoginForMobilink extends Component {
  constructor(props) {
    super(props);

    this.state = {
      phone: "",
      pin: "",
      inputName: "phone",
      inputValue: this.props.msisdn ? this.props.msisdn : "",
      inputName1: "", //tariq
      inputValue1: "", //tariq
      telco: Globals.telco,
      secondServer: Globals.secondServer ? true : false,
      regex: Globals.regex,
      phonePlaceholder: Globals.login.phonePlaceholder,
      SubscriptionPackage: Globals.login.SubscriptionPackages ? "daily" : "",
      pinPlaceholder: Globals.login.pinPlaceholder,
      pinSent: false,
      user: [],
      btnTxt: "Continue",
      btnDisbaled: false,
      message: "",
      heading: Globals.login.enterNumber,
      enterPin: Globals.login.enterPin,
      strings: {
        somethingWentWrong: "Something went wrong. Please try again later!",
        invalidPin: "Invalid Pincode!",
        invalidPhone: Globals.login.invalidPhone,
      },
      confirmBtnText: "Confirm",
      confirmErrorMsg: "",
      userTelcoName: "",
      userTelcoPricePoint: "",
      showInputFlow: true,
    };

    this.handleKeypress = this.handleKeypress.bind(this);
    this.login = this.login.bind(this);
    this.loginValuesChange = this.loginValuesChange.bind(this);

    this.apiPath = Globals.NodeApi + "api/";
    this.textInput = React.createRef();
    this.isResendPinFlow = false;

    localStorage.setItem("countryCode", "pk");
  }

  async componentDidMount() {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.msisdn) {
      this.setState({ inputValue: nextProps.msisdn });
    }
  }

  handleKeypress = function(e) {
    if (e.key === "Enter") {
      this.login();
    }
  };

  async login() {
    const phone = this.state.phone.replace(/ /g, "");
    this.setState({ phone: phone }); // set phone state after internationalization

    let serverResponse = {};
    let subscriptionResponse = {};

    this.setState({
      btnTxt: "Please Wait ...",
      btnDisbaled: true,
      message: "",
    });

    if (this.state.showInputFlow) {
      //appstart or send pin

      let regex = this.state.regex;

      const result = validatePhone(phone, regex);

      if (!result || !phone) {
        //Fail Event Sent to Google for loging.
        handleGoogleEvents(
          "Login",
          `Login-${this.state.telco}`,
          `Phone-Invalid`
        );

        this.setState({
          btnTxt: "CONTINUE",
          btnDisbaled: false,
          message: "You have entered invalid mobile number",
        });
        return false;
      }

      try {
        let subscriptionStatusURL =
          this.apiPath + getSubscriptionAPIURL(Globals.telco, phone);
        subscriptionStatusURL = localStorage.getItem("source")
          ? subscriptionStatusURL + "&source=" + localStorage.getItem("source")
          : subscriptionStatusURL; // for jazzworld

        if (this.state.secondServer) {
          subscriptionStatusURL += "&second_server=1";
        }

        serverResponse = await axios.get(subscriptionStatusURL, {});
        serverResponse = serverResponse.data;

        // new check added for time being
        if (
          serverResponse.generic_response.message === "Invalid Phone number"
        ) {
          this.setState({
            btnTxt: "CONTINUE",
            btnDisbaled: false,
            message: "You have entered invalid mobile number",
          });
          // window.location.reload();
          return;
        }

        if (serverResponse) {
          localStorage.setItem(
            "isSocialProfileAttached",
            serverResponse.remote_response &&
            serverResponse.remote_response.user
              ? serverResponse.remote_response.user.is_social_profile_attached
              : "false"
          );

          this.setState({
            pinMessage:
              serverResponse.remote_response &&
              serverResponse.remote_response.resp &&
              serverResponse.remote_response.resp.disclaimer
                ? serverResponse.remote_response.resp.disclaimer
                : "",
            tncmessage:
              serverResponse.remote_response &&
              serverResponse.remote_response.resp &&
              serverResponse.remote_response.resp.tnc_text
                ? serverResponse.remote_response.resp.tnc_text
                : "",
            userTelcoName:
              serverResponse.remote_response &&
              serverResponse.remote_response.resp
                ? getTelcoName(
                    serverResponse.remote_response.resp.telco_id,
                    serverResponse.remote_response.resp.subscribed_by_id
                  )
                : "",
          });

          let generic_response = {};

          if (
            (Object.keys(serverResponse).length === 0 &&
              serverResponse.constructor === Object) ||
            (!serverResponse.remote_response &&
              !serverResponse.generic_response)
          ) {
            //empty response, means no response from  node server
            // console.log("Step-2 - Tariq", serverResponse);
            generic_response = tempUser(phone); //temporary disable | now enabled as per ali bhai 26-06-19
            // this.setState({ message: "Something went wrong!", btnTxt: 'Continue', btnDisbaled: false });
            // alert("Something went wrong, please check your network.");
          } else if (
            !serverResponse.status &&
            serverResponse.generic_response &&
            serverResponse.generic_response.call_type &&
            serverResponse.generic_response.call_type === "appstart" &&
            serverResponse.error
          ) {
            //appstart failed, remote server must not be responding
            // console.log("Step-3 - Tariq", serverResponse);
            generic_response = tempUser(phone); //temporary disabled | now enabled as per ali bhai 26-06-19
            // this.setState({ message: "Something went wrong. Please try again later!", btnTxt: 'Continue', btnDisbaled: false });
            // alert("Something went wrong, please check your internet connection.");
          } else if (!serverResponse.status) {
            //server responded but ERROR !
            // console.log("Step-4 - Tariq", serverResponse);
            this.setState({
              message: serverResponse.generic_response.message,
              btnTxt: "Continue",
              btnDisbaled: false,
            });
          } else {
            generic_response = serverResponse.generic_response;
          }
        }

        if (
          serverResponse.status &&
          serverResponse.generic_response.is_pin_sent
        ) {
          this.setFlowToRender("pinSent");
        }
      } catch (err) {
        console.log("Error logging in", err);
      }
    } else {
      //pin is sent so call confirm pin start

      let confrimPinResponse = {};
      const pin = this.state.pin;

      try {
        let url =
          this.apiPath +
          "confirmpin?telco=" +
          this.state.userTelcoName +
          "&phone=" +
          phone +
          "&pin=" +
          pin +
          "&sub_type=" +
          this.state.SubscriptionPackage;
        url = localStorage.getItem("source")
          ? url + "&source=" + localStorage.getItem("source")
          : url; // for jazzworld

        if (this.state.secondServer) {
          url += "&second_server=1";
        }

        confrimPinResponse = await axios.get(url, {}).then((response) => {
          if (response.status === 200) {
            // this.setState({
            //     showEPLoaderModal: false
            // });

            confrimPinResponse = response.data ? response.data : null;

            if (confrimPinResponse) {
              let generic_response = {};

              localStorage.setItem(
                "isSocialProfileAttached",
                confrimPinResponse.remote_response &&
                confrimPinResponse.remote_response.user
                  ? confrimPinResponse.remote_response.user
                      .is_social_profile_attached
                  : "false"
              );

              if (
                Object.keys(confrimPinResponse).length === 0 &&
                confrimPinResponse.constructor === Object
              ) {
                // no server response, ERROR ! login with a temporary user
                // generic_response = tempUser(phone);
                this.setState({
                  message: "Something went wrong!",
                  btnTxt: "Continue",
                  btnDisbaled: false,
                });
              } else if (!confrimPinResponse.status) {
                this.setState({
                  message: confrimPinResponse.generic_response.message,
                  btnTxt: "Continue",
                  btnDisbaled: false,
                });
              } else {
                generic_response = confrimPinResponse.generic_response;
              }

              let xAccessToken =
                confrimPinResponse.remote_response &&
                confrimPinResponse.remote_response.user
                  ? confrimPinResponse.remote_response.user.x_access_token
                  : "";

              if (generic_response.subscribed) {
                this.setState({ message: "" });
                // this.setState({ message: '', btnTxt: 'Continue', btnDisbaled: false });

                generic_response.phone = phone;
                generic_response.telco =
                  this.state.userTelcoName === "easypaisa"
                    ? this.state.userOrginalTelco
                    : this.state.userTelcoName;
                generic_response.isEasypaisaSubscription =
                  this.state.userTelcoName === "easypaisa" ? true : false;

                generic_response.xAccessToken = xAccessToken;

                localStorage.setItem("user_logged_in", true);
                localStorage.setItem("user", JSON.stringify(generic_response));

                handleGoogleEvents(
                  "Login",
                  `Login-${this.state.telco}`,
                  `Pin-Confirm-Ok-Subscribed`
                );

                loginUser(generic_response);

                window.location = document.documentURI;
              }
            }
          }
        });
      } catch (err) {
        handleGoogleEvents(
          "Login",
          `Login-${this.state.telco}`,
          `Pin-Confirm-Pin-Error`
        );
        console.log("Error confirming pin", err);
      }
    }
  }

  async sendPinAgain() {
    this.setState({
      showResendButton: false,
      showTimer: true,
      pin: "",
      message: "",
    });

    let subscriptionStatusURL =
      this.apiPath + getSubscriptionAPIURL(Globals.telco, this.state.phone);
    subscriptionStatusURL = localStorage.getItem("source")
      ? subscriptionStatusURL + "&source=" + localStorage.getItem("source")
      : subscriptionStatusURL; // for jazzworld

    if (this.state.secondServer) {
      subscriptionStatusURL += "&second_server=1";
    }

    await axios.get(subscriptionStatusURL, {});
  }

  loginValuesChange = (event) => {
    this.setState({
      [event.target.name]: event.target.value,
      inputValue: event.target.value,
    });
  };

  setSubscriptionPackage = (e) => {
    e = e.target.value;
    let val = e ? e : "";
    this.setState({ SubscriptionPackage: val });
  };

  getPinFlowStates() {
    let pinFlowState = {
      phonePlaceholder: this.state.phonePlaceholder,

      pinSent: true,
      message: "",
      btnTxt: "Continue",
      btnDisbaled: false,
      showInputFlow: false,
      showPinFlow: true,
      showSubscriptionFlow: false,
      showEPBundle: false,
      pin: "",
      showTermsandConditions: false,
    };
    return pinFlowState;
  }

  setFlowToRender(flow) {
    let setThisState = {};
    if (flow === "phone" || flow === "resendPin") {
      setThisState = {
        btnDisbaled: false,
        btnTxt: "Continue",
        showInputFlow: true,
        showPinFlow: false,
        showSubscriptionFlow: false,
        showEPBundle: false,
        pin: "",
        userTelcoName: "",
        isUserAlreadySubscribed: false,
        selectedEPBundle: null,
        pinMessage: "",
        tncmessage: "",
        isResendPinFlow: false,
        showTermsandConditions: false,
        message: "",
      };
    } else if (flow === "pinSent") {
      setThisState = this.getPinFlowStates();
    }

    this.setState(setThisState);
  }

  renderPhoneInput = () => {
    return (
      <div>
        <div className="mb-1" style={{ fontSize: "1.7rem", fontWeight: "600" }}>
          {this.state.heading}
        </div>
        <input
          name={this.state.inputName}
          type="text"
          ref={this.textInput}
          placeholder={this.state.phonePlaceholder}
          value={this.state.phone}
          onChange={this.loginValuesChange}
          onKeyPress={this.handleKeypress}
          autoComplete="off"
          className="telco-input"
          maxLength="13"
        />
        <p
          className="message mt-3 text-danger text-center"
          style={{ fontSize: "16px" }}
        >
          {this.state.message}
        </p>
      </div>
    );
  };

  renderLoginFlow = () => {
    return (
      <div>
        <div
          style={{
            textAlign: "center",
            marginBottom: "20px",
            fontSize: "1.7rem",
            lineHeight: "1.2 !important",
            fontWeight: "600",
          }}
        >
          Subscribe now to watch Premium Cricket Content and Play Exciting
          Games.
        </div>
        <br />

        <div>
          {this.renderPhoneInput()}
          {Globals.login.SubscriptionPackages && !this.state.pinSent ? (
            <div className="radio">
              <label className="radio-inline">
                <input
                  type="radio"
                  value="daily"
                  name="radioB"
                  defaultChecked
                  onChange={this.setSubscriptionPackage}
                  style={{ paddingLeft: "10px" }}
                  autoComplete="off"
                />{" "}
                Daily{" "}
              </label>

              <label className="radio-inline">
                <input
                  type="radio"
                  value="monthly"
                  name="radioB"
                  onChange={this.setSubscriptionPackage}
                />{" "}
                Monthly{" "}
              </label>
            </div>
          ) : (
            ""
          )}

          <button
            className="submit border-0 w-50 btn bg-red text-white rounded-0 mt-5 p-3 mb-lg-5 text-uppercase font-weight-bold fs-1p3"
            onClick={this.login}
            disabled={this.state.btnDisbaled}
          >
            {this.state.btnTxt}
          </button>
        </div>
      </div>
    );
  };

  renderPin = () => {
    return (
      <div>
        <div
          className="text-center mb-3"
          style={{ fontSize: "1.7rem", fontWeight: "600" }}
        >
          {" "}
          Pin Verification{" "}
        </div>
        <h6 className="text-center mb-3">
          We have sent PIN code via SMS to following number
        </h6>
        <h6 className="text-center mb-5">
          {" "}
          {this.state.phone}{" "}
          <span
            onClick={() => this.setFlowToRender("resendPin")}
            style={{ cursor: "pointer" }}
          >
            {" "}
            <img src="/images/edit.svg" alt="" />
          </span>{" "}
        </h6>
        {/* <div>{ this.renderTelcosForPin()}</div> */}

        <div className="">
          {!this.state.showResendButton && (
            <div className="text-center mb-3 d-none">
              <Timer
                initialTime={10000}
                direction="backward"
                timeToUpdate={500}
                checkpoints={[
                  {
                    time: 0,
                    callback: () => this.setState({ showResendButton: true }),
                  },
                ]}
              >
                <Timer.Seconds />
              </Timer>
            </div>
          )}

          <input
            name={"pin"}
            //className="phone nostyle border-bottom bg-transparent w-100 py-3 px-2 h5 m-0"
            type="text"
            ref={this.textInput}
            autoFocus={true}
            placeholder={"Enter your pin code here"}
            value={this.state.pin}
            onChange={this.loginValuesChange}
            onKeyPress={this.handleKeypress}
            autoComplete="off"
            style={{
              width: 100 + "%",
              textAlign: "left",
              backgroundColor: "white",
              borderBottomColor: "lightgray",
              paddingLeft: "10px",
              paddingBottom: 8 + "px",
              borderRadius: 0,
              height: "65px",
              border: "none",
              background: "#F8F7F7",
              outline: "none",
              fontSize: "1.6rem",
            }}
            maxLength="6"
            max="6"
          />

          <p className="message mt-3 text-danger text-center">
            {this.state.message}
          </p>

          {Globals.login.SubscriptionPackages && !this.state.pinSent ? (
            <div className="radio">
              <label className="radio-inline">
                <input
                  type="radio"
                  value="daily"
                  name="radioB"
                  defaultChecked
                  onChange={this.setSubscriptionPackage}
                  autoComplete="off"
                />{" "}
                Daily{" "}
              </label>

              <label className="radio-inline">
                <input
                  type="radio"
                  value="monthly"
                  name="radioB"
                  onChange={this.setSubscriptionPackage}
                  autoComplete="off"
                />{" "}
                Monthly{" "}
              </label>
            </div>
          ) : (
            ""
          )}

          <button
            className="submit border-0 w-50 btn bg-red text-white rounded-0 mt-4 p-3 mb-lg-5 text-uppercase font-weight-bold fs-1p3"
            onClick={this.login}
            disabled={this.state.btnDisbaled}
          >
            {this.state.btnTxt}
          </button>

          <h5 className="text-center mt-5"> Didn’t receive Code? </h5>
          <h4
            className={
              "text-center mt-2 " +
              (this.state.showResendButton
                ? "clickable-text"
                : "unclickable-text")
            }
            onClick={() => {
              this.state.showResendButton && this.sendPinAgain();
            }}
          >
            {" "}
            Resend Pin{" "}
          </h4>

          <p
            className={"text-center w-50"}
            style={{ margin: "15px auto 0 auto" }}
          >
            {this.state.pinMessage}
          </p>
        </div>
      </div>
    );
  };

  render() {
    return (
      <div id="main-section">
        <div className="register-login card p-4 pb-5 px-lg-5 py-lg-4">
          {this.state.showInputFlow ? this.renderLoginFlow() : this.renderPin()}
          <span className="app-download my-lg-5 py-lg-5 mt-5">
            {this.state.tncmessage &&
              this.state.tncmessage.length > 0 && (
                <Link to={"/tnc/" + this.state.userTelcoName}>
                  <p
                    style={{ fontSize: "10px" }}
                    className={"text-center text-danger"}
                  >
                    {this.state.tncmessage}
                  </p>
                </Link>
              )}
            <img
              onClick={this.props.downloadApp}
              className="w-100"
              src={Globals.login.image}
              alt=""
            />
          </span>
        </div>
      </div>
    );
  }
}

export default LoginForMobilink;
